import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get working hours reports
export const getWorkingHoursReports = createAsyncThunk(
  "workingHoursReports/getWorkingHoursReports",
  async (params, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) {
        throw new Error("No authentication token found");
      }
      const queryParams = new URLSearchParams();
      queryParams.append("year", params.year);
      queryParams.append("month", params.month);
      const url = `${BASE_URL}/hr-reports/working-hours?${queryParams.toString()}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get working hours reports!";
      return rejectWithValue(message);
    }
  },
);
